import componentsComboboxDeviceCatalogComboboxEn from './device-catalog-combobox/default';
import componentsComboboxDeviceComboboxEn from './device-combobox/default';
import componentsComboboxDeviceMultiSelectComboboxEn from './device-multi-select-combobox/default';
import componentsComboboxInstallableSoftwareSelectorComboboxEn from './installable-software-selector-combobox/default';
import componentsComboboxPersonMultiSelectComboboxEn from './person-multi-select-combobox/default';
import componentsComboboxPersonSelectorComboboxEn from './person-selector-combobox/default';
import componentsComboboxSoftwareSelectorComboboxEn from './software-selector-combobox/default';

const componentsComboboxEn = {
  deviceCatalogCombobox: componentsComboboxDeviceCatalogComboboxEn,
  deviceCombobox: componentsComboboxDeviceComboboxEn,
  deviceMultiSelectCombobox: componentsComboboxDeviceMultiSelectComboboxEn,
  installableSoftwareSelectorCombobox:
    componentsComboboxInstallableSoftwareSelectorComboboxEn,
  noResults: 'No results',
  personMultiSelectCombobox: componentsComboboxPersonMultiSelectComboboxEn,
  personSelectorCombobox: componentsComboboxPersonSelectorComboboxEn,
  placeAndFleetCombobox: {
    placeholder: 'Select place or fleet',
    searchPlaceholder: 'Place or fleet name',
  },
  softwareSelectorCombobox: componentsComboboxSoftwareSelectorComboboxEn,
};

export default componentsComboboxEn;
